// src/features/engine/components/ProjectResults.jsx

import { useProgramEngine } from "../../engine/context/ProgramEngineContext";

export default function ProjectResults() {

  const { project, program } = useProgramEngine();

  return (
    <div style={{ padding: 24 }}>

      <h2>Results</h2>

      <p><strong>{project.title}</strong></p>
      <p>{program.title}</p>

      <p>Results coming soon...</p>

    </div>
  );
}